import React from "react";
import { Route, Switch } from "react-router-dom";
import Area from "../../views/Area/Area";
import BreakdownDetail from "../../views/BreakdownDetail/BreakdownDetail";
import BreakdownEffect from "../../views/BreakdownEffect/BreakdownEffect";
import BreakdownList from "../../views/BreakdownList/BreakdownList";
import BreakDownListTable from "../../views/BreakdownList/BreakdownListTable";
import BreakdownReasonDetail from "../../views/BreakdownReasonDetail/BreakdownReasonDetail";
import BreakdownReasonGroup from "../../views/BreakdownReasonGroup/BreakdownReasonGroup";
import BreakdownReasonPlace from "../../views/BreakdownReasonPlace/BreakdownReasonPlace";
import BreakdownRootCause from "../../views/BreakdownRootCause/BreakdownRootCause";
import CostCenter from "../../views/CostCenter/CostCenter";
import AddEquipmentToGroup from "../../views/Equipment/AddEquipmentToGroup";
import Equipment from "../../views/Equipment/Equipment";
import EditEquipment from "../../views/Equipment/EditEquipment";
import EquipmentReport from "../../views/EquipmentReport/EquipmentReport";
import EquipmentType from "../../views/EquipmentType/EquipmentType";
import GetAccessToken from "../../views/GetAccessToken/GetAccessToken";
import Login from "../../views/Login/Login";
import MaintenancePauseReason from "../../views/MaintenancePauseReason/MaintenancePauseReason";
import MaintenanceType from "../../views/MaintenanceType/MaintenanceType";
import OperatorMainPage from "../../views/OperatorMainPage/OperatorMainPage";
import OperatorRequests from "../../views/OperatorRequests/OperatorRequest";
import Overview from "../../views/Overview/Overview";
import Plant from "../../views/Plant/Plant";
import AddRelationToPool from "../../views/Pool/AddRelationToPool";
import Pool from "../../views/Pool/Pool";
import ProfileTabs from "../../views/Profile/ProfileTabs";
import ReportBreakdown from "../../views/ReportBreakdown/ReportBreakdown";
import AddFunctionToRoleGroup from "../../views/RoleGroup/AddFunctionToRoleGroup";
import RoleGroup from "../../views/RoleGroup/RoleGroup";
import TechnicianMainPage from "../../views/TechnicianMainPage/TechnicianMainPage";
import NotificationList from "../../views/NotificationList/NotificationList";
import ApprovalPage from "../../views/ApprovalPage/ApprovalPage";
import AddGroupsToUser from "../../views/User/AddGroupsToUser";
import User from "../../views/User/UserNew";
import AddUserGroupToPool from "../../views/UserGroup/AddUserGroupToPool";
import UserGroup from "../../views/UserGroup/UserGroup";
import AutonomousCheckItemGroup from "../../views/CheckItemGroup/AutonomousCheckItemGroup";
import PlannedCheckItemGroup from "../../views/CheckItemGroup/PlannedCheckItemGroup";
import NavContainer from "../NavigationContainer/NavContainer";
import GoogleAnalytics from "../../components/GoogleAnalytics";
import PersonnelSummaryList from "../../views/PersonelSummary/PersonnelSummary";
import CreatePlannedMaintenance from "../../views/CreatePlannedMaintenance/CreatePlannedMaintenance";
import CreateEwoForm from "../../views/EwoForm/EwoForm";
import PlannedMaintenanceTaskList from "../../views/PlannedMaintenanceList/PlannedMaintenanceTaskList";
import PlannedMaintenanceDetail from "../../views/PlannedMaintenanceDetail/PlannedMaintenanceDetail";
import PlannedMaintenanceOrderList from "../../views/PlannedMaintenanceOrderList/PlannedMaintenanceOrderList";
import PlannedMaintenanceCalendar from "../../views/PlannedMaintenanceCalendar/PlannedMaintenanceCalendar";
import PlannedMaintenanceTaskListTable from "../../views/PlannedMaintenanceList/PlannedMaintenanceTaskListTable";
import AutonomousMaintenanceOrderList from "../../views/AutonomousMaintenanceOrderList/AutonomousMaintenanceOrderList";
import EditAutonomousMaintenanceOrder from "../../views/CreateAutonomousMaintenance/EditAutonomousMaintenanceOrder";
import AutonomousMaintenanceList from "../../views/AutonomousMaintenanceList/AutonomousMaintenanceList";
import AutonomousMaintenanceDetail from "../../views/AutonomousMaintenanceDetail/AutonomousMaintenanceDetail";
import AutonomousMaintenanceOrderTaskList from "../../views/AutonomousMaintenanceOrderTaskList/AutonomousMaintenanceOrderTaskList";
import MasterData from "../../views/MasterData/MasterData";
import AutonomousTaskCheckList from "../../views/AutonomousMaintenanceDetail/AutonomousTaskCheckList";
import PlannedTaskCheckList from "../../views/PlannedMaintenanceDetail/PlannedTaskCheckList";
import LocalizationDataUpload from "../../views/LocalizationData/LocalizationDataUpload";
import PlannedMaintenanceUpdate from "../../views/PlannedMaintenanceUpdate/PlannedMaintenanceUpdate";
import Lists from "../../views/BreakdownList/Lists";
import MachineSummaryLists from "../../views/MachineMaintenanceSummaryList/MachineSummaryLists";
import OrderForm from "../../views/BreakdownDetail/OrderForm";
import MailGroups from "../../views/MailGroups/MailGroups";
import EquipmentNotes from "../../views/EquipmentNotes/EquipmentNotes";
import CreateMultiplePlannedMaintenance from "../../views/CreateMultiplePlannedMaintenance/CreateMultiplePlannedMaintenance";
import ToBePlanned from "../../views/ToBePlanned/ToBePlanned";
import CreateToBePlanned from "../../views/ToBePlanned/CreateToBePlanned";
import SingleMaintenanceUpdate from "../../views/SingleMaintenance/SingleMaintenanceUpdate";
import EkedEquipment from "../../views/EkedEquipment/EkedEquipment";
import CheckItemGroupExcel from "../../views/CheckItemGroupExcelUpload/CheckItemGroupUpload";
import MachineMaintenanceSummaryList from "../../views/MachineMaintenanceSummaryList/MachineMaintenanceSummaryList";
import MachineMaintenanceSummaryListPlanned from "../../views/MachineMaintenanceSummaryList/MachineMaintenanceSummaryListPlanned";
import ShiftPlans from "../../views/ShiftPlans/ShiftPlans";
import SparePart from "../../views/SparePart/SparePart";
import SparePartList from "../../views/SparePart/SparePartList";
import AddSparePart from "../../views/SparePart/AddSparePart";
import SparePartExcelUpload from "../../views/SparePartExcelUpload/SparePartExcelUpload";
import EwoForms from "../../views/EwoForms/EwoForms";

// Redux , Saga start
import configureStore from "../../store/configureStore";
import { Provider } from "react-redux";

import { LoginCallback, SecureRoute, Security } from "@okta/okta-react";
import { toRelativeUrl } from "@okta/okta-auth-js";
import GenericSnackbar from "../../components/Snackbar/GenericSnackbar";

// Theme
import { ThemeModeContext } from "../../theme/ThemeModeContext";
import { getDesignTokens } from "../../theme/Theme";
import { createTheme, ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { trTR, enUS, ruRU, roRO, thTH } from "@mui/material/locale";
import moment from "moment";
import SparePartNoteDefinitions from "../../views/SparePart/SparePartNoteDefinitions";
import NoAuth from "../../views/NoAuth/NoAuth";
import NotFound from "../../views/NotFound/NotFound";
import { oktaAuth } from "../../utils/OktaAuth";

const store = configureStore();

function App() {
    const restoreOriginalUri = async (_oktaAuth, originalUri) => {
        console.log("restoreOriginalUri");
        window.location.replace(toRelativeUrl(originalUri, window.location.origin));
    };

    const [mode, setMode] = React.useState(localStorage.getItem("themeMode") ?? "light");
    const themeMode = React.useMemo(
        () => ({
            toggleThemeMode: () => {
                setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
                localStorage.setItem("themeMode", localStorage.getItem("themeMode") === "light" ? "dark" : "light");
            },
        }),
        []
    );

    let themeLang = enUS;
    moment.locale("en");
    if (localStorage.getItem("i18nextLng") == "tr-TR") {
        themeLang = trTR;
        moment.locale("tr");
    } else if (localStorage.getItem("i18nextLng") == "ru-RU") {
        themeLang = ruRU;
        moment.locale("ru");
    } else if (localStorage.getItem("i18nextLng") == "ro-RO") {
        themeLang = roRO;
        moment.locale("ro");
    } else if (localStorage.getItem("i18nextLng") == "th-TH") {
        themeLang = thTH;
        moment.locale("th");
    }

    const theme = React.useMemo(() => createTheme(getDesignTokens(mode), themeLang), [mode]);

    return (
        <Provider store={store}>
            <ThemeModeContext.Provider value={themeMode}>
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={theme}>
                        <CssBaseline />
                        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
                            <div className="App">
                                <NavContainer />
                                <Switch>
                                    <SecureRoute path="/" exact component={Overview} />
                                    <SecureRoute path="/equipment" exact component={Equipment} />
                                    <SecureRoute path="/editequipment/:id?" exact component={EditEquipment} />
                                    <SecureRoute path="/addequipmenttogroup/:id?" component={AddEquipmentToGroup} />
                                    <SecureRoute path="/equipmenttype" exact component={EquipmentType} />
                                    <SecureRoute path="/equipmentreport" exact component={EquipmentReport} />
                                    <SecureRoute path="/area" exact component={Area} />
                                    <SecureRoute path="/plant" exact component={Plant} />
                                    <SecureRoute path="/costcenter" exact component={CostCenter} />
                                    <SecureRoute path="/maintenancetype" exact component={MaintenanceType} />
                                    <SecureRoute path="/maintenancepausereason" exact component={MaintenancePauseReason} />
                                    <SecureRoute path="/usergroups" exact component={UserGroup} />
                                    <SecureRoute path="/addusergrouptopool/:id?" component={AddUserGroupToPool} />
                                    <SecureRoute path="/breakdownreasonplace" exact component={BreakdownReasonPlace} />
                                    <SecureRoute path="/breakdownreasongroup" exact component={BreakdownReasonGroup} />
                                    <SecureRoute path="/breakdownreasondetail" exact component={BreakdownReasonDetail} />
                                    <SecureRoute path="/breakdowneffect" exact component={BreakdownEffect} />
                                    <SecureRoute path="/breakdownrootcause" exact component={BreakdownRootCause} />
                                    <SecureRoute path="/users" exact component={User} />
                                    <SecureRoute path="/addusertogroup/:id?" component={AddGroupsToUser} />
                                    <SecureRoute path="/rolegroup" exact component={RoleGroup} />
                                    <SecureRoute path="/addfunctiontorolegroup/:id?" exact component={AddFunctionToRoleGroup} />
                                    <SecureRoute path="/pool" exact component={Pool} />
                                    <SecureRoute path="/addrelationtopool/:id?" component={AddRelationToPool} />
                                    <SecureRoute path="/profile" exact component={ProfileTabs} />
                                    <SecureRoute path="/personnelsummary" exact component={PersonnelSummaryList} />
                                    <SecureRoute path="/ewoForms" exact component={EwoForms} />
                                    <SecureRoute path="/getaccesstoken" exact component={GetAccessToken} />
                                    <SecureRoute path="/operatormainpage" exact component={OperatorMainPage} />
                                    <SecureRoute path="/operatorrequests" exact component={OperatorRequests} />
                                    <SecureRoute path="/reportbreakdown" exact component={ReportBreakdown} />
                                    <SecureRoute path="/technicianmainpage" exact component={TechnicianMainPage} />
                                    <SecureRoute path="/breakdownlist" exact component={BreakdownList} />
                                    <SecureRoute path="/breakdown-list-table" exact component={BreakDownListTable} />
                                    <SecureRoute path="/breakdowndetail" exact component={BreakdownDetail} />
                                    <SecureRoute path="/notificationlist" exact component={NotificationList} />
                                    <SecureRoute path="/approval-page" exact component={ApprovalPage} />
                                    <SecureRoute path="/create-planned-maintenance" exact component={CreatePlannedMaintenance} />
                                    <SecureRoute path="/create-ewo-form" exact component={CreateEwoForm} />
                                    <SecureRoute path="/planned-maintenance-task-list" exact component={PlannedMaintenanceTaskList} />
                                    <SecureRoute path="/planned-maintenance-detail/:id?" component={PlannedMaintenanceDetail} />
                                    <SecureRoute path="/planned-maintenance-order-list" component={PlannedMaintenanceOrderList} />
                                    <SecureRoute path="/planned-maintenance-calendar" component={PlannedMaintenanceCalendar} />
                                    <SecureRoute path="/planned-maintenance-task-list-table" component={PlannedMaintenanceTaskListTable} />
                                    <SecureRoute path="/autonomous-maintenance-order-list" component={AutonomousMaintenanceOrderList} />
                                    <SecureRoute path="/autonomous-maintenance-order-task-list" component={AutonomousMaintenanceOrderTaskList} />
                                    <SecureRoute path="/autonomous-maintenance-detail/:id?" component={AutonomousMaintenanceDetail} />
                                    <SecureRoute path="/create-autonomous-maintenance-order/:id?" component={EditAutonomousMaintenanceOrder} />
                                    <SecureRoute path="/autonomous-checkitemgroup" exact component={AutonomousCheckItemGroup} />
                                    <SecureRoute path="/planned-checkitemgroup" exact component={PlannedCheckItemGroup} />
                                    <SecureRoute path="/masterdata-upload" exact component={MasterData} />
                                    <SecureRoute path="/localization-upload" exact component={LocalizationDataUpload} />
                                    <SecureRoute path="/planned-maintenance-update" exact component={PlannedMaintenanceUpdate} />
                                    <SecureRoute path="/autonomous-maintenance-list" exact component={AutonomousMaintenanceList} />
                                    <SecureRoute path="/autonomous-task-check-list/:id?" exact component={AutonomousTaskCheckList} />
                                    <SecureRoute path="/planned-task-check-list/:id?" exact component={PlannedTaskCheckList} />
                                    <SecureRoute path="/lists" exact component={Lists} />
                                    <SecureRoute path="/machine-summary-lists" exact component={MachineSummaryLists} />
                                    <SecureRoute path="/order-form/:id?" exact component={OrderForm} />
                                    <SecureRoute path="/mail-groups" exact component={MailGroups} />
                                    <SecureRoute path="/equipment-notes" exact component={EquipmentNotes} />
                                    <SecureRoute path="/create-multiple-planned-maintenance" exact component={CreateMultiplePlannedMaintenance} />
                                    <SecureRoute path="/to-be-planned" exact component={ToBePlanned} />
                                    <SecureRoute path="/create-to-be-planned" exact component={CreateToBePlanned} />
                                    <SecureRoute path="/single-maintenance-update" exact component={SingleMaintenanceUpdate} />
                                    <SecureRoute path="/eked-equipment" exact component={EkedEquipment} />
                                    <SecureRoute path="/check-item-group-excel" exact component={CheckItemGroupExcel} />
                                    <SecureRoute path="/shift-plans" exact component={ShiftPlans} />
                                    <SecureRoute path="/machine-maintenance-summary" exact component={MachineMaintenanceSummaryList} />
                                    <SecureRoute path="machine-maintenance-summary-planned" exact component={MachineMaintenanceSummaryListPlanned} />
                                    <SecureRoute path="/spare-part" exact component={SparePart} />
                                    <SecureRoute path="/spare-part-list" exact component={SparePartList} />
                                    <SecureRoute path="/spare-part-note-definitions" exact component={SparePartNoteDefinitions} />
                                    <SecureRoute path="/add-spare-part/:id?" exact component={AddSparePart} />
                                    <SecureRoute path="/spare-part-excel" exact component={SparePartExcelUpload} />
                                    <SecureRoute path="/noauth" exact component={NoAuth} />
                                    <Route exact path="/implicit/callback" component={LoginCallback} />
                                    <Route path="/Login" component={Login} />
                                    <SecureRoute path="*" component={NotFound} />
                                </Switch>
                                <GoogleAnalytics />
                                <GenericSnackbar />
                            </div>
                        </Security>
                    </ThemeProvider>
                </StyledEngineProvider>
            </ThemeModeContext.Provider>
        </Provider>
    );
}

export default App;
